import * as styles from "./NavItem.css";

import { useAtomValue } from "jotai";
import { useTransition } from "react";

import { Spinner } from "@frontend/components/atoms/Spinner";

import { useAddressBookActions } from "../../hooks/useAddressBookActions";
import { loadingCategoryKeyAtom, selectedCategoryAtom } from "../../stores";
import type { Category } from "../../types";

type NavItemProps = {
  category: Category;
};

export function NavItem({ category }: NavItemProps) {
  const { selectCategory } = useAddressBookActions();

  const selectedCategory = useAtomValue(selectedCategoryAtom);
  const loadingCategoryKey = useAtomValue(loadingCategoryKeyAtom);

  const isSelected = selectedCategory?.key === category.key;
  const isLoading = loadingCategoryKey === category.key;
  const isNew = category.type === "new";

  const [isPending, startTransition] = useTransition();

  return (
    <div
      className={styles.item({ selected: isSelected })}
      onClick={() => {
        startTransition(async () => {
          await selectCategory(category);
        });
      }}
    >
      <span className={styles.label}>{category.name}</span>
      <span className={styles.count({ badge: isNew, isLoading })}>
        {isLoading ? <Spinner size={14} /> : category.contactCount.toString()}
      </span>
    </div>
  );
}
